<template>
  <div>
    <faq />
  </div>
</template>

<script>
import faq from "./partials/faq";
const CRUD_CODE = "faq";
export default {
  title: `${CRUD_CODE}.title`,
  name: "FaqIndex",
  components: {
    faq,
  },
};
</script>

<style scoped></style>
